// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3501":"d5003082","4193":"fd96fd56","6774":"1eb538c0"}[chunkId] + ".chunk.css";
};